let my_dictionary = {  
  'menu-questionnaire': 'Questionnaire' 
,  'menu-new': 'New' 
,  'menu-edit': 'Edit' 
,  'menu-question': 'Question' 
,  'menu-chapter': 'Chapter' 
,  'menu-back': 'Back' 
,  'menu-closed': 'Closed' 
,  'menu-open': 'Open' 
,  'menu-mixed': 'Mixed' 
,  'menu-matrix': 'Matrix' 
,  'menu-rank': 'Rank' 
,  'menu-quota': 'Quota' 
,  'menu-visual': 'Visual' 
,  'menu-preview': 'Preview' 
,  'menu-add': 'Add' 
,  'menu-edit-chapter': 'Edit chapter' 
,  'menu-delete': 'Delete' 
,  'menu-copy': 'Copy' 
,  'menu-copyto': 'Copy to' 
,  'menu-add-media': 'Add media' 
,  'menu-page': 'Page' 
,  'menu-properties': 'Properties' 
,  'menu-rules': 'Rules' 
,  'menu-conditions': 'Conditions' 
,  'menu-settings': 'Settings' 
,  'menu-binds': 'Binds' 
,  'menu-random-split': 'Random split' 
,  'menu-edit-quest-split': 'Edit question split' 
,  'menu-new-quest-split': 'New question split' 
,  'menu-random': 'Random' 
,  'menu-new-quest-random': 'New question random' 
,  'menu-edit-quest-random': 'Edit question random' 
,  'menu-print': 'Print' 
,  'menu-data-test': 'Data test' 
,  'menu-simulation': 'Simulation' 
,  'menu-design': 'Design' 
,  'menu-comment': 'Comment' 
,  'menu-answer': 'Answer' 
,  'menu-themes': 'Themes' 
,  'menu-header': 'Header' 
,  'menu-footer': 'Footer' 
,  'menu-welcome': 'Welcome' 
,  'menu-goodbye': 'Goodbye' 
,  'menu-exit': 'Exit' 
,  'menu-skin': 'Survey design' 
,  'menu-import--export': 'Import \ Export' 
,  'menu-default': 'default' 
,  'menu-import': 'Import' 
,  'menu-importmain': 'Importmain' 
,  'menu-export': 'Export' 
,  'menu-exportmain': 'Exportmain' 
,  'menu-duplicate': 'Duplicate' 
,  'menu-listfile': 'List File' 
,  'menu-manage': 'Manage' 
,  'menu-view-vars': 'View vars' 
,  'menu-project': 'Project' 
,  'menu-new-project': 'New Project' 
,  'menu-manage-project': 'Manage project' 
,  'menu-project-groups': 'Project groups' 
,  'menu-permission': 'Permissions' 
,  'menu-users': 'Users' 
,  'menu-add-user': 'Add User' 
,  'menu-edit-user': 'Edit User' 
,  'menu-groups': 'Groups' 
,  'menu-add-group': 'Add Group' 
,  'menu-edit-group': 'Edit Group' 
,  'menu-supervision': 'Control' 
,  'menu-general': 'General' 
,  'menu-map': 'Map' 
,  'menu-list': 'List' 
,  'menu-allocation': 'Allocation' 
,  'menu-multilangual': 'Multilingual' 
,  'jsint-quit-sim': 'Quit simulation?' 
,  'jsint-exit': 'Exit' 
,  'jsint-wrongnum': 'This is not a valid question number for this simulation' 
,  'jqst-a-manual-num': 'A manual number that you have previously inserted seems to be contradicting with the new question you wish to add.&lt;br /&gt;The manual number will be deleted, please be advised!&lt;br /&gt;The problematic question numbers are: Manual no=%s , Ordinal No=%s ' 
,  'jqst-manual-numbe': 'Manual number problem' 
,  'jqst-not-yet-comp': 'Not yet completed.' 
,  'jqst-msword-is-cu': 'MSword is currently unavailable, please stay tuned for updates' 
,  'jqst-no-items-sel': 'No items selected' 
,  'jqst-you-can-sele': 'You can select only one question to edit' 
,  'jqst-no-questions': 'No questions selected' 
,  'jqst-are-you-sure': 'Are you sure you wish to delete selected items?' 
,  'jqst-this-manual': 'This manual number is invalid because there is already a question with this number' 
,  'jqst-this-manual80': 'This manual number is invalid because there is already a answer with this number' 
,  'jqst-you-must-sel': 'You must select a least one question from the right table' 
,  'jqst-you-must-sel27': 'You must select only 1 column' 
,  'jqst-you-must-sel38': 'You must select 1 value from each menu' 
,  'jqst-select-paren': 'Select parent or sub questions, you can&#039;t select both' 
,  'jqst-are-you-sure42': 'Are you sure you wish to delete this item?' 
,  'jlis-are-you-sure': 'Are you sure you wish to delete this List File? Any lost data could not be recovered if deleted.' 
,  'jlis-will-be-comp': 'Will be completed after survey engine module.' 
,  'jlis-all-unsaved': 'All unsaved changes will be lost' 
,  'jlis-you-must-sel': 'You must select a least 2 columns' 
,  'jlis-delete-origi': 'Delete original columns?' 
,  'jlis-you-must-sel32': 'You must select a least 1 column' 
,  'jlis-are-you-sure43': 'Are you sure you want to delete %s columns?' 
,  'jlis-delete': 'Delete' 
,  'jlis-you-must-sel29': 'You must select a least 1 row' 
,  'jlis-yes': 'Yes' 
,  'jlis-no': 'No' 
,  'jlis-are-you-sure40': 'Are you sure you want to delete %s rows?' 
,  'jlis-you-must-ass': 'You must assign at least one filed as phone/Email' 
,  'jper-no-items-sel': 'No items selected' 
,  'jper-you-are-abou': 'You are about to delete an entire group. PLEASE consider the consequences. This action will lead to deleting at least all group&#039;s users and is irreversible. What do you want to do?' 
,  'jper-no-users-sel': 'No users selected' 
,  'jper-you-can-sele': 'You can select only one group to edit' 
,  'jper-deleting-sel': 'Deleting selected users will completely erase them from the database and they will no longer be able to login to Scout. Are you sure?' 
,  'jper-you-can-sele36': 'You can select only one user to edit' 
,  'jpro-are-you-sure': 'Are you sure you wish to delete the Project %s ?' 
,  'jpro-delete-proje': 'Delete project' 
,  'jpro-syntax-valid': 'Valid Syntax' 
,  'jpro-error:-wrong': 'Error: incorrect variable structure.' 
,  'jpro-all-question': 'All questionnaires must have the exact same structure, Please check questions' 
,  'jpro-please-enter': 'Please enter a new value name' 
,  'jque-are-you-sure': 'Are you sure you wish to delete %s questionnaire?' 
,  'jque-delete-quest': 'Delete questionnaire' 
,  'jque-file-size-of': 'File size exceeds  50 MB' 
,  'jque-error': 'Error' 
,  'jque-this-format': 'This format is not supported, we support:\nImage: tif, gif, jpg, png, bmp\nVideo: avi, wmv, mp4, mp3, flv, swf' 
,  'jque-maximum-valu': 'Maximum value must be &lt;= ' 
,  'jque-cat-value-mu': 'Category value must be a round number' 
,  'jque-value-must-b': 'Value must be numeric' 
,  'jque-value-can-no': 'Value can not be empty' 
,  'jque-max/min-valu': 'Max/Min value must set as numeric' 
,  'jque-maximum-maxi': 'Maximum limit must be bigger than minimum' 
,  'jque-min-and-max': 'Min and Max values can not be empty' 
,  'jque-upper-scale': 'Upper scale must be bigger by at least 1 than lower scale' 
,  'jque-maximum-valu59': 'Maximum value must be at least equal to minimum value' 
,  'jque-max/min-valu34': 'Max/Min value must a round Number' 
,  'jque-you-are-abou': 'You are about to change the question structure. This means you might have inconsistent data or empty columns. Do you approve?' 
,  'jque-are-you-sure44': 'Are you sure you wish to delete random rule?' 
,  'jque-are-you-sure45': 'Are you sure you wish to delete random split?' 
,  'jque-are-you-sure38': 'Are you sure you wish to random split?' 
,  'jque-unsaved-cond': 'Unsaved conditions will be lost. Continue? Yes | No' 
,  'jsur-wrong-time-f': 'Incorrect time format' 
,  'jsur-wrong-data-f': 'Incorrect date format' 
,  'jsur-please-selec': 'Please select an option.' 
,  'jsur-you-must-loc': 'You must  man all categories or all images' 
,  'jpro-please-selec': 'Please select an option.' 
,  'jpro-values-sum-n': 'Values sum need to be 100%' 
,  'jpro-please-selec92': 'Please select a leading variable by dragging and dropping one of the C or clustered variables' 
,  'jpro-please-selec40': 'Please select Axis and Cluster variables' 
,  'jpro-please-selec14': 'Please select ' 
,  'jque-in-this-case': 'In this case you are allowed to attach only images' 
,  'jsur-you-have-to': 'You have to mark an answer for this question' 
,  'jsur-you-must-sel': 'You must select %s - %s answers (Selected: %s)' 
,  'jsur-you-must-sel35': 'You must select at least %s answers (Selected: %s)' 
,  'jsur-you-can-choo': 'You can choose no more than %s answers (Selected: %s)' 
,  'jsur-the-values-y': 'The values you have inserted must sum up exactly to' 
,  'jsur-you-have-to37': 'You have to enter answer for question' 
,  'jsur-this-field-i': 'This field is required.' 
,  'jsur-you-have-to40': 'You have to mark an answer for question ' 
,  'jsur-you-have-to41': 'You have to enter answer for question %s!' 
,  'jsur-you-must-ent': 'You must enter at least {0} and no more than {1} characters for this question' 
,  'jsur-you-must-ent56': 'You must enter at least {0} characters for this question' 
,  'jsur-you-must-ent60': 'You must enter no more than {0} characters for this question' 
,  'cal-this-user-al': 'This user already logged. Please contact to administrator if you need unlock this user.' 
,  'cal-phone-list-c': 'Phone list completed' 
,  'cal-no-sample-fi': 'No Sample file is set for this project, Please consult your Administrator or Supervisor for more information' 
,  'pro-no-fields-fo': 'No fields found' 
,  'pro-project-succ': 'Project successfully deleted' 
,  'pro-please-speci': 'Please specify project' 
,  'pro-listfile-not': 'List File not selected' 
,  'pro-project-succ26': 'Project &lt;b&gt;%s&lt;/b&gt; successfully saved' 
,  'pro-please-selec': 'Please selec c vars' 
,  'pro-error': 'Error' 
,  'que-answers-succ': 'Answers successfully deleted' 
,  'que-no-binds-for': 'No binds for this question' 
,  'que-bind-saved': 'Bind saved' 
,  'que-questionnair': 'Questionnaire' 
,  'que-questionnair29': 'Questionnaire has been added.' 
,  'que-questionnair32': 'Questionnaire successfully saved' 
,  'que-questions-wa': 'Questions was copied successfully' 
,  'que-questionnair34': 'Questionnaire successfully deleted' 
,  'que-questionnair37': 'Questionnaire duplicated successfully' 
,  'que-questionnair35': 'Questionnaire imported successfully' 
,  'que-question-suc': 'Question successfully saved' 
,  'que-question-not': 'Question not found' 
,  'que-maximum-valu': 'Maximum value must be at least +1 bigger than minimum value' 
,  'que-change-of-qu': 'Change of question type was completed successfully' 
,  'que-not-allow-me': 'Not allow media for this question type' 
,  'que-chapter-succ': 'Chapter successfully deleted' 
,  'que-chapter-succ26': 'Chapter successfully saved' 
,  'que-chapter-not': 'Chapter not found' 
,  'que-design-form': 'Design form successfully saved' 
,  'que-items:-%s-de': 'items: %s deleted.' 
,  'que-random-rule': 'Random rule successfully saved' 
,  'que-invalid-id': 'Invalid ID' 
,  'que-id:-%-delete': 'ID: % deleted.' 
,  'que-no-questionn': 'No questionnaire selected' 
,  'que-condition-su': 'Condition successfully saved' 
,  'que-random-split': 'Random split' 
,  'que-id:': 'ID: ' 
,  'set-settings-sav': 'Settings saved' 
,  'sur-at-first-add': 'At first add questions' 
,  'cal-intermission': 'Intermission' 
,  'cal-cancel': 'Cancel' 
,  'cal-respondent-p': 'Respondent Profile' 
,  'cal-phone:': 'Phone:' 
,  'cal-opening-line': 'Opening line' 
,  'cal-redial-later': 'Redial later on:' 
,  'cal-statuses:': 'Statuses:' 
,  'cal-comments': 'Comments' 
,  'cal-next-respond': 'Next Respondent' 
,  'cal-choice-proje': 'Select project' 
,  'cal-logout': 'Logout' 
,  'pro-all': 'All' 
,  'pro->values-matc': 'Values matching cluster criteria' 
,  'pro-quantity': 'Quantity' 
,  'pro-totlal': 'Total' 
,  'pro-choose': 'Choose' 
,  'pro-default': 'Default' 
,  'pro-edit-again': 'Edit again' 
,  'pro-general': 'General' 
,  'pro-variables-&': 'Variables &amp; Population' 
,  'pro-sampling-met': 'Sampling Method' 
,  'pro-quotas': 'Quotas' 
,  'pro-blacklist': 'Blacklist' 
,  'pro-survey-statu': 'Survey Status' 
,  'pro-export': 'Export' 
,  'pro-before-step': 'Before step' 
,  'pro-after-c': 'After ' 
,  'pro-distribution': 'Distribution by:' 
,  'pro-value': 'Value' 
,  'pro-percent': 'Percent' 
,  'pro-nest': 'NEST' 
,  'pro-quota': 'Quota' 
,  'pro-status': 'Status' 
,  'pro-variable': 'variable' 
,  'pro-question': 'Question' 
,  'pro-select': 'Select' 
,  'pro-add': 'Add' 
,  'pro-this-project': 'This project' 
,  'pro-all-projects': 'All projects' 
,  'pro-test': 'Test' 
,  'pro-save-rule': 'Save rule' 
,  'pro-load-rule': 'Load rule' 
,  'pro-save-&-run': 'Save &amp; Run' 
,  'pro-withdraw-fro': 'Withdraw from' 
,  'pro-apply-to': 'Apply to' 
,  'pro-according-to': 'According to' 
,  'pro-action': 'Action' 
,  'pro-identify-by': 'Identify by' 
,  'pro-time-limit': 'Time limit' 
,  'pro-recurrence': 'Recurrence' 
,  'pro-run-every-(d': 'Run every (days):' 
,  'pro-next-run:': 'Next run:' 
,  'pro-end-run:': 'End run:' 
,  'pro-you-have-suc': 'You have successfully saved the rule, but it hasn&#039;t been executed. Would you like to execute it now?' 
,  'pro-yes': 'Yes' 
,  'pro-records-avai': 'Records Available:' 
,  'pro-withdraw:': 'Withdraw:' 
,  'pro-apply-to:': 'Apply to:' 
,  'pro-according-to13': 'According to:' 
,  'pro-action:': 'Action:' 
,  'pro-identify-by:': 'Identify by:' 
,  'pro-time-limit:': 'Time limit:' 
,  'pro-recurrence:': 'Recurrence:' 
,  'pro-forecast': 'Forecast' 
,  'pro-unlimited': 'Unlimited' 
,  'pro-limited': 'Limited' 
,  'pro-days:': 'Days:' 
,  'pro-rule-name:': 'Rule name:' 
,  'pro-select:': 'Select:' 
,  'pro-other-projec': 'Other project' 
,  'pro-select-vars': 'Select vars' 
,  'pro-clusters': 'Clusters' 
,  'pro-proportions': 'Proportions' 
,  'pro-export-proje': 'Export project files:' 
,  'pro-choose-expor': 'Choose export type:' 
,  'pro-spss-data': 'SPSS data' 
,  'pro-exel-data': 'Excel data' 
,  'pro-exel-log': 'Excel log' 
,  'pro-open-answers': 'Open answers' 
,  'pro-survey-summa': 'Survey summary' 
,  'pro-choose-surve': 'Choose survey status:' 
,  'pro-completed': 'Completed' 
,  'pro-use-encoding': 'Use encoding:' 
,  'pro-enabled': 'Enabled' 
,  'pro-disabled': 'Disabled' 
,  'pro-view-answers': 'View answers' 
,  'pro-interview:': 'Interview:' 
,  'pro-view': 'View' 
,  'pro-enter-projec': 'Project name:' 
,  'pro-enter-projec21': 'Project manual number (optional):' 
,  'pro-comments:': 'Comments:' 
,  'pro-list-file': 'List File' 
,  'pro-fictive': 'Fictive' 
,  'pro-banner': 'Banner' 
,  'pro-other-panel': 'Panel' 
,  'pro-you-must-sel': 'You must select project type' 
,  'pro-choose-list': 'List File:' 
,  'pro-choose-group': 'Select group:' 
,  'pro-no-group': 'No group' 
,  'pro-choose-quest': 'Questionnaire:' 
,  'pro--select-': '-select-' 
,  'pro-sample-size:': 'Sample size:' 
,  'pro-ratio:': 'Ratio:' 
,  'pro-interval-set': 'Interval settings' 
,  'pro-daily': 'Daily' 
,  'pro-weekly': 'Weekly' 
,  'pro-month': 'Month' 
,  'pro-quarterly': 'Quarterly' 
,  'pro-portion:': 'Portion:' 
,  'pro-current-port': 'Current portion:' 
,  'pro-list-file-se': 'List File sensitivity:' 
,  'pro-static': 'Static' 
,  'pro-cumulative': 'Cumulative' 
,  'pro-set-all-valu': 'Set all values to' 
,  'pro-test-info': 'Test Info' 
,  'pro-drag-and-dro': 'Drag and drop leading var' 
,  'pro-choose-depen': 'Choose dependet control variables (OPTIONAL)' 
,  'pro-choose-a-sam': 'Choose a Sampling Method:' 
,  'pro-axis-variabl': 'Axis variable' 
,  'pro-clusterd-var': 'Clusterd variable' 
,  'pro-create': 'Create' 
,  'pro-cluster-list': 'Cluster list:' 
,  'pro-axis-values': 'Axis Values Found' 
,  'pro-axis-values20': 'Axis Values Selected' 
,  'pro-total-record': 'Total Records Found' 
,  'pro-records-sele': 'Records Selected' 
,  'pro-%-in-populat': '% in Population' 
,  'pro-probability': 'Probability' 
,  'pro-stratified': 'Stratified' 
,  'pro-clustered': 'Clustered' 
,  'pro-systematic': 'Systematic' 
,  'pro-as-is': 'As is' 
,  'pro-total:': 'Total:' 
,  'pro-distribution12': 'Distribution' 
,  'pro-create&edit': 'Create &amp; Edit Respond Statuses' 
,  'pro-setup-email': 'Setup email template' 
,  'pro-setup-email20': 'Setup reminder template' 
,  'pro-automatic-cl': 'Automatic client dialer:' 
,  'pro-setup-respon': 'Setup respondent return policy' 
,  'pro-languages-se': 'Languages' 
,  'pro-automatic-ba': 'Automatic balancer:' 
,  'pro-act': 'Act' 
,  'pro-create-sampl': 'Create sample file' 
,  'pro-send-test-su': 'Send test survey' 
,  'pro-send-to-resp': 'Send to respondents' 
,  'pro-send-reminde': 'Send reminder to respondents' 
,  'pro-create-gener': 'Get link' 
,  'pro-set-online': 'Set Online' 
,  'pro-set-offline': 'Set Offline' 
,  'pro-online': 'Online' 
,  'pro-shedule': 'Schedule' 
,  'pro-remiders': 'Reminders' 
,  'pro-offline-mode': 'Offline mode' 
,  'pro-save-templat': 'Save Template' 
,  'pro-sender:': 'Sender:' 
,  'pro-subject:': 'Subject:' 
,  'pro-language-sel': 'Language selection' 
,  'pro-drag-and-dro51': 'Drag and drop language from left menu to right menu' 
,  'pro-available-la': 'Available languages' 
,  'pro-default-lang': 'Default language' 
,  'pro-other-langua': 'Other languages' 
,  'pro-setup-offlin': 'Setup Offline mode date' 
,  'pro-setup-automa': 'Setup Automatic Reminders' 
,  'pro-choose-dates': 'Choose dates and save times for reminders' 
,  'pro-remider': 'Reminder' 
,  'pro-set-priority': 'Set priority for records allocated to interviewers:' 
,  'pro-selected-sor': 'Selected sorting vars hierarchy' 
,  'pro-translate': 'translate' 
,  'pro-new-status': 'New status' 
,  'pro-return-every': 'Return every' 
,  'pro-show-status': 'Show status' 
,  'pro-start&end': 'Start&amp;End' 
,  'pro-start': 'Start' 
,  'pro-end': 'End' 
,  'pro-import-&-exp': 'Import &amp; Export Statuses' 
,  'pro-import': 'Import' 
,  'pro-sort': 'Sort' 
,  'pro-please-enter': 'Please enter new value name:' 
,  'pro-records-avai18': 'Records available:' 
,  'pro-c-variables': 'C Variables' 
,  'pro-f-variables': 'F Variables' 
,  'pro-variables': 'Variables' 
,  'pro-main|surv': 'Main|Surv' 
,  'pro-nesting': 'Nesting' 
,  'pro-recode': 'Recode' 
,  'pro-load-templat': 'Load Template' 
,  'pro-asc': 'ASC' 
,  'pro-desc': 'DESC' 
,  'que-get-started': 'Get started' 
,  'que-about-scout': 'About Scout' 
,  'que-our-website': 'Our Website' 
,  'que-report-an-er': 'Report an Error' 
,  'que-log-out': 'Log Out' 
,  'que-listfile': 'List File' 
,  'que-project': 'Project' 
,  'que-permission': 'Permission' 
,  'que-supervision': 'Control' 
,  'que-encoding': 'Encoding' 
,  'que-settings': 'Settings' 
,  'que-sqdl': 'SQDL' 
,  'que-properties': 'Properties' 
,  'que-rules': 'Rules' 
,  'que-preview': 'Preview' 
,  'que-design': 'Design' 
,  'que-themes': 'Themes' 
,  'que-parent': 'Parent' 
,  'que-remove': 'Remove' 
,  'que-bind': 'Bind' 
,  'que-unbind': 'Unbind' 
,  'que-previous': 'Previous' 
,  'que-choose-optio': 'Choose option' 
,  'que-show': 'show' 
,  'que-hide': 'hide' 
,  'que-parent6': 'parent' 
,  'que-gradual': 'gradual' 
,  'que-current-ques': 'Current questionnaire' 
,  'que-selected-que': 'Selected questions' 
,  'que-filter': 'Filter' 
,  'que-select-a-que': 'Select a question, your selected questions will be copied Before this question.' 
,  'que-go-to-end': 'Go To End' 
,  'que-copy': 'Copy' 
,  'que-some-problem': 'Some problems were detected when deliting' 
,  'que-menu-font-ex': 'Text design preview' 
,  'que-use-parent-s': 'Use parent style' 
,  'que-default-font': 'Default font' 
,  'que-font-size': 'Font size' 
,  'que-color': 'Color' 
,  'que-background-c': 'Background Color' 
,  'que-bold': 'Bold' 
,  'que-italic': 'Italic' 
,  'que-save-&-edit': 'Save &amp; Edit' 
,  'que-save-&-exit': 'Save &amp; Exit' 
,  'que-manual': 'Manual' 
,  'que-question-tex': 'Question text' 
,  'que-media': 'Media' 
,  'que-script': 'Script' 
,  'que-rnd': 'Rnd' 
,  'que-chapter': 'Chapter' 
,  'que-start\end': 'Start\End' 
,  'que-click-on-fil': 'Click on field to select color.' 
,  'que-ruller-color': 'Ruler color:' 
,  'que-pointer-colo': 'Pointer color:' 
,  'que-show-selecte': 'Show the selected value under the ruler:' 
,  'que-finished': 'Finished' 
,  'que-page-propert': 'Page properties' 
,  'que-distance:-qu': 'Distance: Question to answers' 
,  'que-distance:-to': 'Distance: To next question' 
,  'que-apply-to-all': 'Apply to all questionnaires' 
,  'que-choice-quest': 'Choose questionnaire to' 
,  'que-slelect-skin': 'Select skin:' 
,  'que-url': 'URL' 
,  'que-save-&-exi': 'Save &amp; Exit' 
,  'que-use-default': 'Use default' 
,  'que-remark': 'Remark' 
,  'que-answer': 'Answer' 
,  'que-closed': 'Closed' 
,  'que-open': 'Open' 
,  'que-mixed': 'Mixed' 
,  'que-matrix': 'Matrix' 
,  'que-visual': 'Visual' 
,  'que-add-media': 'Add media' 
,  'que-page': 'Page' 
,  'que-conditions': 'Conditions' 
,  'que-binds': 'Binds' 
,  'que-print': 'Print' 
,  'que-data-test': 'Data test' 
,  'que-simulation': 'Simulation' 
,  'que-header': 'Header' 
,  'que-footer': 'Footer' 
,  'que-welcome': 'Welcome' 
,  'que-goodbye': 'Goodbye' 
,  'que-choice-quest33': 'Choose questionnaire to duplicate' 
,  'que-enter-file-l': 'Enter file location' 
,  'que-enter-questi': 'Enter questionnaire name (leave blank to inherit original name)' 
,  'que-this-may-tak': 'This may take a few minutes' 
,  'que-font-size:': 'Font size:' 
,  'que-color:': 'Color:' 
,  'que-background-c17': 'Background Color:' 
,  'que-hidden-comme': 'Hidden comments' 
,  'que-chapter-text': 'Chapter text' 
,  'que-hide-chapter': 'Hide chapter' 
,  'que-single-pick': 'Single Pick Radio Button' 
,  'que-single-pick21': 'Single Pick Combo Box' 
,  'que-multi-answer': 'Multi Answer Check Box' 
,  'que-no-answer-co': 'No Answer Comment' 
,  'que-show-navigat': 'Show navigation:' 
,  'que-hide-next-bu': 'Hide Next button until video finished:' 
,  'que-hide-text:': 'Hide text:' 
,  'que-text': 'Question Text' 
,  'que-upload': 'Upload' 
,  'que-border:': 'Border:' 
,  'que-question-fil': 'Question Fill Color:' 
,  'que-text-size:': 'Text size:' 
,  'que-text-color:': 'Text Color:' 
,  'que-select-quest': 'Select question:' 
,  'que-insert': 'Insert' 
,  'que-chained': 'Chained' 
,  'que-horizontal': 'Horizontal' 
,  'que-vertical': 'Vertical' 
,  'que-multi-compar': 'Multi comparison' 
,  'que-sum': 'Sum' 
,  'que-form': 'Form' 
,  'que-rank': 'Rank' 
,  'que-visual-compa': 'Visual comparison' 
,  'que-browse...': 'Browse...' 
,  'que-show-text:': 'Show Answers text' 
,  'que-any-text': 'Any Text' 
,  'que-number': 'Number' 
,  'que-date': 'Date' 
,  'que-time': 'Time' 
,  'que-select-point': 'Select pointer style:' 
,  'que-drop-down': 'Drop Down' 
,  'que-fit-in': 'Fit In' 
,  'que-podium': 'Podium' 
,  'que-limit-answer': 'Limit answers (Min\Max)' 
,  'que-time-limit-(': 'Time limit (seconds)' 
,  'que-display-on-s': 'display on screen' 
,  'que-save-answer': 'Save answer time' 
,  'que-save-order-o': 'Save order of answers' 
,  'que-indicate': 'Indicate' 
,  'que-ordinal': 'Ordinal' 
,  'que-hide4': 'Hide' 
,  'que-click-object': 'Click Object' 
,  'que-ruler': 'Ruler' 
,  'que-shelf-simula': 'Shelf Simulator' 
,  'que-question-com': 'Question comments' 
,  'que-answers-list': 'Answers list' 
,  'que-mul': 'MUL' 
,  'que-rnd3': 'RND' 
,  'que-actions': 'Actions' 
,  'que-list-new-ans': 'New answers list' 
,  'que-add-filter': 'Add filter' 
,  'que-parent-quest': 'Parent question' 
,  'que-id': 'ID' 
,  'que-child-questi': 'Child questions' 
,  'que-answer-scale': 'Answer scale for all child questions' 
,  'que-same': 'Same' 
,  'que-different': 'Different' 
,  'que-closed-answe': 'Closed Answers' 
,  'que-answer-text': 'Answer text' 
,  'que-answer-scale19': 'Answer scale for q:' 
,  'que-id=': 'ID=' 
,  'que-answer-scale28': 'Answer scale for q: All' 
,  'que-hidden-comme14': 'Hidden comment' 
,  'que-must': 'Must' 
,  'que-prewous': 'Previous' 
,  'que-allow-n\a-op': 'Allow N/A option.' 
,  'que-enter-custom': 'Enter custom text. default is: N/A' 
,  'que-organize': 'Organize' 
,  'que-child-column': 'Child column' 
,  'que-child-row': 'Child row' 
,  'que-answer-scale12': 'Answer scale' 
,  'que-open-answer': 'Open Answer' 
,  'que-min': 'Min' 
,  'que-ranking-cate': 'Ranking categories' 
,  'que-images': 'Images' 
,  'que-exactly': 'Exactly' 
,  'que-range': 'Range' 
,  'que-minimun:': 'Minimun:' 
,  'que-maximum:': 'Maximum:' 
,  'que-force-pointe': 'Force pointer into categories' 
,  'que-free-movemen': 'Free movement   Save decimal' 
,  'que-lower-scale': 'Lower scale' 
,  'que-upper-scale': 'Upper scale' 
,  'que-limit-charac': 'Limit Characters' 
,  'que-max': 'Max' 
,  'que-question-sub': 'Question sub-type' 
,  'que-rank-type': 'Rank type' 
,  'que-question-man': 'Question manual number' 
,  'que-question-id': 'Question ID' 
,  'que-children-que': 'Child questions type' 
,  'que-children-que23': 'Child questions type' 
,  'que-questions-su': 'Questions sub-type' 
,  'que-allow-multia': 'Allow multianswer' 
,  'que-answers': 'Answers' 
,  'que-name:': 'Name:' 
,  'que-alocated-to': 'Allocated to' 
,  'que-disabled': 'DISABLED' 
,  'que-random-quest': 'Random Questions Rules' 
,  'que-display:': 'display:' 
,  'que-of': 'of' 
,  'que-questions-li': 'Questions List:' 
,  'que-select-quest15': 'Select Question' 
,  'que-random-split22': 'Random Split Questions' 
,  'que-random-split20': 'Random Split Answers' 
,  'que-for': 'For' 
,  'que-if': 'If' 
,  'que-gui': 'GUI' 
,  'que-skip': 'Skip' 
,  'que-to:': 'To:' 
,  'que-validate': 'Validate' 
,  'que-comment:': 'Comment:' 
,  'que-set': 'Set' 
,  'que-else': 'Else' 
,  'que-else-if': 'Else If' 
,  'que-question:': 'Question:' 
,  'que-select-quest16': 'Select Question' 
,  'que-is': 'Is' 
,  'que-is-not': 'Is Not' 
,  'que-any': 'Any' 
,  'que-or': 'Or' 
,  'que-and': 'And' 
,  'que-continue': 'Continue' 
,  'que-content': 'Content' 
,  'que-order': 'Order' 
,  'que-entrance': 'Entrance' 
,  'que-exit': 'Exit' 
,  'que-filter:': 'Filter: ' 
,  'set-some-problem': 'Some problems were detected with the submitted form.' 
,  'set-user-has-bee': 'User has been saved.' 
,  'set-available-la': 'Available Languages' 
,  'set-language-nam': 'Language Name in English' 
,  'set-name-in-orig': 'Name in Origin Language' 
,  'set-language-dir': 'Language direction' 
,  'set-import-&-exp': 'Import &amp; Export' 
,  'set-import-&-exp15': 'import &amp; Export' 
,  'set-full-diction': 'Full Dictionary' 
,  'set-search': 'Search' 
,  'set-constant-nam': 'Constant name' 
,  'sup-choode-group': 'Select from:' 
,  'sup-free': 'Free' 
,  'sup-interviewers': 'Interviewers' 
,  'sup-release-all': 'Release All' 
,  'sup-move-all': 'Release' 
,  'sup-created': 'Created' 
,  'sup-last-used': 'Last Used' 
,  'sup-allocated': 'Allocated' 
,  'sup-allocate': 'Allocate' 
,  'sup-need': 'NEED' 
,  'sup-done': 'DONE' 
,  'sup-left': 'LEFT' 
,  'sup-allocated9': 'ALLOCATED' 
,  'sup-status': 'STATUS' 
,  'sup-remove': 'REMOVE' 
,  'sup-info': 'INFO' 
,  'sup-view-&-monit': 'View &amp; Monitor' 
,  'sup-allocate\rel': 'Allocate\Release' 
,  'sup-project-name': 'Project name' 
,  'sup-log-off': 'Log Off' 
,  'sur-quit': 'Quit' 
,  'sur-end-of-simul': 'End Of Simulation' 
,  'sur-questionnair': 'Questionnaire name:' 
,  'sur-questionnair23': 'Questionnaire comments:' 
,  'sur-questionnair19': 'Questionnaire date:' 
,  'sur-questionnair21': 'Questionnaire Creator:' 
,  'sur-skip-to-q': 'Skip to Q' 
,  'sur-next>>>': 'Next' 
,  'sur-time-left:': 'Time Left:' 
,  'sur-enter': 'Enter' 
,  'sur-(rnd)': '(RND)' 
,  'sur-(mul)': '(MUL)' 
,  'sur-show-scripts': 'Show Scripts' 
,  'sur-last-modifie': 'Last modified:' 
,  'sur-creation-dat': 'Creation date:' 
,  'sur-creator-name': 'Creator name:' 
,  'sur-n/a': 'N/A' 
,  'sur-your-choice:': 'Your choice:' 
,  'sur-drop-here': 'Drop here' 
,  'jsur-exit': 'Exit' 
,  'sur-qchar': 'Q' 
,  'jsur-wrongnum': 'This is not a legal question number for this simulation' 
,  'jsur-quit-sim': 'Quit simulation?' 
,  'set-export': 'Export' 
,  'set-import': 'Import' 
,  'set-import-file': 'Import file' 
,  'set-selct-lang': 'Select languages' 
,  'que-assistance': 'Assistance' 
,  'jlis-are-you-sure-to-delete': 'Are you sure you want to delete this Rule?' 
,  'sur-your-choice': 'Your choice:' 
,  'jsur-sum-between': 'The values you have inserted must sum up between %s and %s' 
,  'jsur-you-mus-aloca': 'You must locate all categories or allocate all images' 
,  'jsur-quit-sur': 'You are leaving this survey, however if you choose to return, you will continue from where you left off. Are you sure you wish to log out?' 
,  'menu-postcollection': 'Postcollection' 
,  'menu-postcollection-encoding': 'Encoding' 
,  'menu-postcollection-proofreading': 'Proofreading' 
,  'menu-postcollection-export': 'Export' 
,  'jenc-more': 'More' 
,  'jenc-less': 'Less' 
,  'jenc-is-currently-allocated-to': 'is currently allocated to' 
,  'jenc-warning-allocated-1': 'WARNING! Releasing this user if still at work may cause immediate loss of data. Please be absolutely sure the user has logged off. Are you sure you want to release this user and allocate yourself?' 
,  'jenc-warning-allocated-2': 'WARNING! Releasing this user if still at work may cause immediate loss of data. Please be absolutely sure the user has logged off. Are you sure you want to release this user and allocate yourself/other user?' 
,  'jenc-warning-allocated-3': 'You cannot release allocation while user is still online. Please contact Admin for force releasing in case the user is actually NOT online and needs to be removed. WARNING! Releasing this user if still at work may cause immediate loss of data.' 
,  'pro-by-variable': 'By variable' 
,  'pro-manual-emails': 'Manual emails' 
,  'pro-by-status': 'By statuses' 
,  'pro-save&edit': 'Save now' 
,  'pro-save&exit': 'Save &amp; Exit' 
,  'sup-i-totaltime': 'Total time' 
,  'sup-i-stoptime': 'Stop time' 
,  'sup-i-tasktime': 'Task time' 
,  'pro-subject-empty': 'Error: Subject is empty !' 
,  'pro-sender-empty': 'Error: Sender is empty !' 
,  'pro-sendername-empty': 'Error: Sender name is Empty!' 
,  'pro-select-empty': 'Please select respondents option!' 
,  'set-keyword': 'By keyword' 
,  'pro-recreate-sampl': 'Sample file' 
,  'pro-manualsend-overquota': 'You cannot send manual emails because you are using C quotas.' 
,  'pro-sendername': 'Sender name:' 
,  'pro-send-test-remind': 'Send test reminder' 
,  'pro-header-sent-test-survey': 'Send a test survey' 
,  'pro-header-sent-test-reminder': 'Sent a test reminder' 
,  'pro-send-survey': 'Send Survey' 
,  'pro-send-reminder': 'Send Reminder' 
,  'pro-template-empty': 'Error: Template is empty !' 
,  'pro-filtered-send': 'Send popup' 
,  'pro-pro--select-': 'select questionnaire' 
,  'pro-absent-emails': 'Emails not found:' 
,  'pro-incorrect-emails': 'Incorrect emails:' 
,  'pro-search': 'Search' 
,  'pro-blacklist-items': 'Blacklist items' 
,  'pro-filter': 'Filter:' 
,  'pro-email': 'Email' 
,  'pro-date': 'Dates' 
,  'pro-comments': 'Comments' 
,  'pro-select-all': 'Select All' 
,  'pro-remove-entry': 'Remove entry' 
,  'pro-select-status': 'Select status' 
,  'pro-not-started': 'Not started' 
,  'pro-stopped': 'Stopped' 
,  'pro-finished': 'Finished' 
,  'pro-not-sent': 'Not Sent' 
,  'pro-select-vars-values': 'Values' 
,  'pro-filter-all': 'All' 
,  'pro-unselect-all': 'Unselect All' 
,  'pro-Date-blacklist': 'Date blacklisted' 
,  'pro-Comments-blacklist': 'Comments' 
,  'pro-Email-blacklist': 'Email\Phone' 
,  'jpro-remove-error': 'Remove Error!' 
,  'jpro-remove-success': 'Remove Success' 
,  'que-rule-deleted': 'Condition successfully deleted' 
,  'que-new-rule': 'New condition' 
,  'que-entr-cond': 'Entrance condition' 
,  'que-exit-cond': 'Exit condition' 
,  'jpro-bad-quotas': 'You have quota questions with missing values or values that don&#039;t sum up to 100%. Please recheck and then put the survey online. Go to Quotas tab for more information.' 
,  'que-single-pick22': 'Single Pick Drop Down' 
,  'jpro-conf-recreate': 'You are about to delete all collected data, this is irreversible . are you ABSOLUTELY SURE you wish to do it?' 
,  'pro-change-size': 'Change Size' 
,  'pro-manage-size': 'Change sample size' 
,  'pro-select-project-edit': 'Select project to edit' 
,  'que-mandatory': 'Mandatory' 
,  'super-export-to-excel': 'Export to Excel' 
,  'super-statuses-by-inter': 'Statuses by interviewers' 
,  'survey-select': '-select-' 
,  'jenc-confirm-delete': 'Are you sure you want to delete ' 
,  'jenc-warning-released-1': 'WARNING! Releasing this user if still at work may cause immediate loss of data. Please be absolutely sure the user has logged off. Are you sure you want to release this user?' 
,  'jenc-warning-released-2': 'You cannot release allocation while user is online. Please contact Admin for force releasing in case the user is actually NOT online and needs to be removed. WARNING! Releasing this user if still at work may cause immediate loss of data.' 
,  'jenc-please-re-allocate-this': 'Please re-allocate if you need to encode this' 
,  'jenc-is-currently-released': ' is currently released.' 
,  'jenc-this-question-is-now-allocated-to': 'This question is now allocated to' 
,  'que-limit-charac-val': 'Limit values' 
,  'jenc-is-dont-copy': 'The category can&#039;t be copied!' 
,  'jenc-is-currently-copy': 'The categories copied successfully.' 
,  'jenc-structure-error-dont-copy': 'Structure error' 
,  'jenc-error-category-exist': 'Category already exists' 
,  'sup-que-quot-error': 'This Quota Question has been modified;   Quota values in the Project for this question need to be re-defined.' 
,  'pro-concatenated-vars': 'Concatenated Vars' 
,  'pro-concat-del-error': 'You cannot delete this variable. Project has already started. To clear this variable you have to clear the sample file in project-&gt;survey status' 
,  'pro-concat-del-confirm': 'Are you sure you want to delete this var?' 
,  'jpro-concat-del-error': 'You cannot delete this variable. Project has already started. To clear this variable you have to clear the sample file in project-&gt;survey status' 
,  'jpro-concat-del-confirm': 'Are you sure you want to delete this var?' 
,  'jpro-select-listfile': 'Select List File' 
,  'pro-change-sample': 'Change Sample' 
,  'pro_current': 'Current' 
,  'pro_new': 'New' 
,  'pro_add_list_file': 'Add from List File:' 
,  'pro_select_list_file': 'Select List File' 
,  'pro-total': 'Total' 
,  'pro-new-quota': 'New Quota' 
,  'menu-new-bind': 'New bind' 
,  'menu-list-bind': 'Configured Binds' 
,  'que-bind-deleted': 'Bind deleted' 
,  'jque-fordel-cond': 'Are you sure you want to delete the condition?' 
,  'jpro-all': 'All' 
,  'jlis-blacklisting': 'Blacklisting' 
,  'jlis-records': 'records' 
,  'pro-manual-blacklis': '' 
,  'pro-manual-blacklist': 'Manual Blacklist' 
,  'pro-rules': 'Rules' 
,  'pro-bt-save-edit': 'Save now' 
,  'pro-bt-save-exit': 'Save &amp; Exit' 
,  'pro-bt-blacklist': 'Blacklist' 
,  'jlis-blacklist-settings': 'Blacklist settings' 
,  'jlis-select-limit': 'Time limit (days)' 
,  'jlis-cencel': 'Cancel' 
,  'jlis-blacklist': 'Blacklist' 
,  'pro-Days-left-blacklist': 'Days left' 
,  'pro-Project-blacklist': 'Project' 
,  'pro-Source-blacklist': 'Source' 
,  'pro-Withdraw': 'Withdraw' 
,  'pro-Apply': 'Apply to' 
,  'pro-According': 'According to' 
,  'pro-add-rule': 'Add Rule' 
,  'jenc-show-default': 'Show proofed Vs original' 
,  'proof-modified-by': 'Modified by' 
,  'proof-last-modified': 'Last modified' 
,  'proof-end-time': 'Interview End time' 
,  'proof-id': 'ID' 
,  'jenc-custom-questions-dont-save': 'Custom setting not saved' 
,  'jenc-proofing-questions-currently-save': 'Proofreading modifications saved' 
,  'pro-st-completed': 'Completed' 
,  'pro-st-notstarted': 'Not started' 
,  'pro-st-stopped': 'Stopped' 
,  'pro-st-inuse': 'In Use' 
,  'pro-save': 'Save' 
,  'menu-cencel': 'Cancel' 
,  'pro_save': 'Save' 
,  'pro-source': 'Source' 
,  'pro-project': 'Project' 
,  'pro-until': 'Days left' 
,  'pro-untill': 'Days left' 
,  'jpro-statuses': 'Status' 
,  'que-que-show': 'Show selected parameters' 
,  'que-que-hide': 'Hide selected parameters' 
,  'que-err-splitcnt': 'Incorrect display count!' 
,  'jque-err-splitcnt': 'Please input an integer (lower than the number of selected items).' 
,  'jqst-skin-saved': 'Skin design saved' 
,  'que-que-parent66': 'Parent only' 
,  'que-que-gradual': 'Gradual selections' 
,  'jpro-items-add-to-blacklist': 'items added to Blacklist' 
,  'que-hide-qdesign': 'Hide Q |' 
,  'que-hide-qtext': 'Hide text' 
,  'jqst-reset-confirm': 'This action will reset to default all the Skin settings. Are you sure?' 
,  'que-reset-skin': 'Restore default' 
,  'jpro-done': 'Done' 
,  'jpro-in-use': 'In Use' 
,  'jpro-stopped': 'Stopped' 
,  'jpro-over-quota': 'Screened' 
,  'pro-blacklist-rules': 'Blacklist rules' 
,  'jlis-exec-rules': 'Save and execute' 
,  'jlis-nothing-added-in-black-list': 'Rule added but no records added to Blacklist.' 
,  'jlis-test-rules': 'Test rules' 
,  'jlis-add-to-black-list 54 jlis-respondents': '' 
,  'jlis-add-to-black-list': 'This Rule would blacklist' 
,  'jlis-respondents': 'Respondents' 
,  'jno-answers-selected': 'No answers selected' 
,  'jname-empty': 'The name is empty!' 
,  'jcnt-absent': 'Please input an integer (lower than the number of selected items).' 
,  'surv-mobile-disallow': 'This survey is not available for mobile devices' 
,  'prop-subquest-label': 'Show sub-question number' 
,  'jsur-tilt-mobile-msg': 'Please tilt to horizontal mode' 
,  'jproj-are you sure': 'This action will copy all Categories of all Questions,  from the Project selected above to the current Project.  Are you sure?' 
,  'jproj-yes': 'Yes' 
,  'jproj-no': 'No' 
,  'jpro-remove-rules-success': 'Rule removed' 
,  'jlis-unlimited': 'unlimited' 
,  'surv-already-completed': 'According to our records you have already completed this survey. ' 
,  'pro-spam-revention': 'Spam prevention' 
,  'pro-spam-revention:': 'Spam prevention:' 
,  'jenc-bt-restore': 'Restore' 
,  'surv-already-finished': 'Thank you for logging to this survey. Unfortunately, it has already been finished. We will be happy to see you again next time. For further information please &lt;a href=' 
,  'jint-edit-comment': 'edit' 
,  'jint-delete-comment': 'delete' 
,  'jint-failed': 'failed' 
,  'jint-busy': 'busy' 
,  'surv-unavailable': 'Thank you for logging to this survey. Unfortunately, it is currently unavailable. For technical support please &lt;a href=' 
,  'super-response-total': 'Total' 
,  'super-total-respondents-in-sample-file': 'Total respondents in sample file' 
,  'surv-wrong': 'Something is wrong with the survey, please report it to &lt;a href=' 
,  'super-respondent-usage-summary': 'Respondent usage summary' 
,  'surv-wrong-action': 'Wrong action!' 
,  'surv-no-hash': 'No hash found!' 
,  'surv-tech-fail': 'Sorry, system failure - please try again at another time. For tech support please &lt;a href=' 
,  'surv-wrong-lang': 'Wrong language or no language parameter found!' 
,  'surv-screened': 'It seems that your characteristics do not comply with the research requirements. We appreciate your cooperation.' 
,  'surv-wrong-token': 'Wrong token or no token found' 
,  'jenc-bt-clear': 'Clear' 
,  'jenc-hide-default': 'Hide original' 
,  'project-has-been-deleted': 'Please send the word ' 
,  'jlis-listfileexst': 'There is already a List File that has this name' 
,  'que-question-options': 'Select the question options' 
,  'jsur-you-must-ent61': 'Answer should be a number between {0} and {1}' 
,  'jsur-you-must-ent62': 'Answer should be a number not smaller than {0}' 
,  'jsur-you-must-ent63': 'Answer should be a number not bigger than {0}' 
,  'jque-err-chkcnt': 'No questions are selected!' 
,  'que-question-pos': 'Ordinal number' 
,  'jlis-yes-remove': 'Yes' 
,  'jlis-no-remove': 'No' 
,  'jlis-confirmation-remove-entry': 'Selected entries will be removed from Blacklist. Are you sure?' 
,  'jsup-over-negative': 'Negative overflow is not accepted!' 
,  'jsup-set-over': 'Please set Overflow value before turning Quota to Active.' 
,  'jque-need-set-max': 'You must set Maximum value!' 
,  'jlis-add-to-black-list-test': 'This Rule would blacklist' 
,  'jlis-add-to-black-list-realy': 'Rule saved - blacklisted' 
,  'jlis-nothing-added-in-black-list-test': 'Rule not saved - blacklisted' 
,  'jlis-nothing-added-in-black-list-realy': 'Rule added but no records added to Blacklist.' 
,  'survey-success': 'Survey is successfully finished, thanks for your cooperation.' 
,  'menu-mobile-simulation': 'Mobile' 
,  'pro-maccabi-task': 'XperTo' 
,  'que-opn-min': 'Min' 
,  'que-opn-max': 'Max' 
,  'pro-btn-call': 'Call' 
,  'pro-btn-web': 'Web' 
,  'pro-response-statuses': 'Response statuses' 
,  'pro-return-policy': 'Return policy' 
,  'pro-create-testlink': 'Get test link' 
,  'pro-status-edit': 'Edit' 
,  'pro-existing-statuses': 'Existing statuses' 
,  'pro-new': 'New' 
,  'pro-set-default': 'Set default' 
,  'pro-status-name': 'Status name' 
,  'pro-status-type': 'Type' 
,  'pro-status-remove-number': 'Remove number' 
,  'pro-status-loop-return': 'Return' 
,  'pro-status-loop-minutes': 'Interval' 
,  'pro-status-loop-time': 'Attempts' 
,  'jpro-status-select': 'Select template' 
,  'pro-status-meeting': 'Meeting' 
,  'pro-status-language': 'Language' 
,  'pro-status-show-status': 'Show status' 
,  'pro-status-show-select': 'Select show' 
,  'pro-status-show-start': 'Start' 
,  'pro-status-show-end': 'End' 
,  'pro-status-show-both': 'Both' 
,  'pro-status-save': 'Save' 
,  'jpro-status-show-select': 'Show status at:' 
,  'sup-int-alocated': 'Allocated' 
,  'jint-intermission': 'Intermission' 
,  'pro-status-final-remove': 'Final Remove&rlm;' 
,  'menu-sup-map': 'Map' 
,  'sup-int-byproj': 'Project' 
,  'sup-int-state': 'State' 
,  'sup-state-inteview': 'Interview' 
,  'sup-state-online': 'Online' 
,  'sup-state-intermission': 'Intermission' 
,  'sup-state-offline': 'Offline' 
,  'js-sup-map-watch': 'Watch' 
,  'js-sup-map-logof': 'Log Off' 
,  'js-sup-map-message': 'Message' 
,  'js-sup-map-release': 'Release' 
,  'sup-int-name': 'Name' 
,  'sup-int-time': 'Time' 
,  'sup-int-netproduct': 'Net Production' 
,  'sup-int-avgtime': 'Avg. Time' 
,  'sup-int-projname': 'Project Name' 
,  'sup-int-last-q': 'Last Q' 
,  'sup-inte-of-q': 'Of' 
,  'jinterview-no-phone-selected': 'No phone selected!' 
,  'jint-set-phone-status': 'Please set phone status before change respondent!' 
,  'jint-current-phone-nostatus': 'Current phone still has no status!' 
,  'pro-delete': 'Delete' 
,  'jpro-status-confirm-delete': 'Are you sure you want to delete this status?' 
,  'jpro-status-dont-delete': 'This status can&#039;t be removed!' 
,  'jpro-status-save': 'Status Saved' 
,  'jint-overquota-not-survey': 'Respondent is overquota, may not continue.' 
,  'pro-sending-problem': 'Sending problem' 
,  'super-phonelist-usage-summary': 'Phone list usage summary' 
,  'super-restore-selected': 'Restore selected' 
,  'super-select-by': 'Select by' 
,  'jpro-status-language-dublicate': 'Language status already exists - only one is allowed.' 
,  'jpro-status-select-type-require': 'Select status type' 
,  'super-no-c-quotas': 'No C quotas found!' 
,  'jpro-status-name-require': 'Please type name for the status.' 
,  'super-restored-from': 'Restored from status' 
,  'jpro-confirm-template-new': 'Are you sure to remove all exists statuses of project and start new bank of statuses?' 
,  'menu-sup-daily': 'Daily Report' 
,  'proj-error-respondent-exists': 'Error! This project has collected respondents!' 
,  'proj-status-used': 'Error! This status used in survey!' 
,  'jqst-bind-del-confirm': 'Delete Bind Rule?' 
,  'questionnaire_ordinal_number': 'Question ordinal number' 
,  'questionnaire_manual_number': 'Question manual number' 
,  'questionnaire_question_id': 'Question ID' 
,  'pro-project-comment': 'Project comment' 
,  'pro-insert-comments': 'Insert comments' 
,  'supervision-filter': 'Filter' 
,  'supervision-filter-date': 'Date' 
,  'jpro-status-name-wrong': 'Wrong name format or characters - cannot be saved.' 
,  'super-questionnaire': 'Questionnaire' 
,  'super-startedon': 'Started on' 
,  'super-endedon': 'Ended on' 
,  'super-goal': 'Goal' 
,  'proj-auto-dialing': 'Auto dialing' 
,  'pro-call-log': 'Call Log' 
,  'pro-export-token': 'Respondents tokens' 
,  'sup-freq': 'Freq' 
,  'sup-freq-select': 'Select ' 
,  'sup-freq-answer': 'Answer' 
,  'sup-freq-count': 'Count' 
,  'super-id': 'Interviewer' 
,  'super-recovered': 'Recovered Interviews' 
,  'super-completed': 'Completed Interviews' 
,  'super-total': 'Total Interviews' 
,  'super-exit': 'Exits' 
,  'super-intermission': 'Break Intermissions' 
,  'super-task': 'Task Intermissions' 
,  'super-net_production': 'Net Production' 
,  'super-gross_production': 'Gross Production' 
,  'super-intermission_time': 'Breaks time' 
,  'super-task_time': 'Tasks time' 
,  'super-interview_time': 'Total interviewing time' 
,  'super-recovered_interview_time': 'Recovered interviews time' 
,  'super-free_time': 'Free' 
,  'super-total_time': 'Total time' 
,  'super-net_distance': 'Net Distance' 
,  'super-gross_distance': 'Gross Distance' 
,  'super-avg_time': 'Average survey time' 
,  'super-last_login': 'Last login' 
,  'super-last_logout': 'Last logout' 
,  'super-pbx_shirking_time': 'Shirking time' 
,  'super-pbx_loss_time': 'Time loss' 
,  'super-pbx_stopped_time': 'Stopped' 
,  'super-pbx_dialing_time': 'Dialing time' 
,  'super-pbx_talking_time': 'Talking time' 
,  'super-completed_interview_time': 'Completed interviews time' 
,  'jpro-confirm-template-delete': 'Are you sure you want to delete this template?' 
,  'jpro-confirm-template-save': 'Save template as:' 
,  'super-columns-mapping': 'Select columns to display' 
,  'surv-production-template': 'Your current production rate is %production%. You are %fx% from the average production for this survey.&lt;br/&gt;You have finished a total of %total% full surveys until now.' 
,  'pro-fromProject-blacklist': 'From' 
,  'que-form-delete': 'Delete' 
,  'super-total-phones-in-sample-file': 'Total phones in sample file' 
,  'super-status-inuse': 'In Use' 
,  'super-status-free': 'Free' 
,  'super-status-pending': 'Pending' 
,  'super-status-locked': 'Locked' 
,  'super-table-general': 'General' 
,  'super-table-interviewers': 'Interviewers' 
,  'super-table-cquotas': 'C Quotas' 
,  'sup-int-totalbreak': 'Total break' 
,  'sup-int-goal': 'Goal' 
,  'super-project': 'Project' 
,  'super-ratio': 'Ratio' 
,  'jsur-validate-message-digits': 'digits ' 
,  'jpro-err-create-sf-before': 'Please create sample file before this action' 
,  'jpro-err-delete1': 'This Project is online, it cannot be deleted' 
,  'sup-state-free': 'Free' 
,  'menu-reporting': 'Reporting' 
,  'sup-filter-date-start': 'Filter date start' 
,  'sup-filter-date-end': 'Filter date end' 
,  'sup-quest-id': 'Questionnaire ID' 
,  'sup-quest-name': 'Questionnaire name' 
,  'super-interviewer_id': 'Interviewer ID' 
,  'super-interviewer_name': 'Interviewer Name' 
,  'que-warning-used-in-projects': 'This Questionnaire is in use in a Project.  Make sure that any changes made to it, do not interfere with surveys running or data collected' 
,  'sup-state-incall': 'In call' 
,  'sup-role-interviewer': 'Interviewer' 
,  'sup-role-non-interviewer': 'Non Interviewer' 
,  'sup-state-task': 'Task' 
,  'que-switch-project': 'Switch project' 
,  'sup-int-grossproduct': 'Gross Production' 
,  'jsur-validate-message-required': 'Please answer the question.' 
,  'pro-s-variables': 'S Variables' 
,  'sup-state-interview': 'Interview' 
,  'super-daily-per-interveiwer': 'Per Interveiwer' 
,  'pro-choose-observer': 'Select Observer' 
,  'super-cnt-interviewers': 'Count' 
,  'jpro-select-var-cval': 'Value(s) must be selected, for any selected C Variable.' 
,  'menu-interviewers': 'Interviewers' 
,  'sup-clean-filter': 'Clean filter' 
,  'que-mh-unique': 'Qunique' 
,  'que-mh-noparelel': 'Do not allow select same answer twice' 
,  'que-mh-mustsel': 'All answers must be selected' 
,  'pro-select-project-export': 'Select projects for export' 
,  'pro-choose-export-type': 'Select variants of export' 
,  'pro-statuses-call': 'Call statuses' 
,  'pro-statuses-web': 'Web statuses' 
,  'pro-history': 'History' 
,  'pro-last': 'Last' 
,  'menu-exprt-project': 'Export Projects' 
,  'que-bind-type-q-q': 'Question - Question' 
,  'que-bind-type-a-a': 'Answer - Answer' 
,  'que-bind-type': 'Please choose type' 
,  'menu-binds-horiz': 'Horizontal Bind' 
,  'que-bind-incase': 'In case of' 
,  'que-bind-child': 'Connected' 
,  'que-bind-type-q-a': 'Question -Answer' 
,  'que-bind-type-a-q': 'Answer - Question' 
,  'quest-cond-count-of-answers': 'Count of answers of' 
,  'jsqst-proj-sort-notify': 'The questionnaire is in use in the Project.  Are you sure you wish to move selected items?' 
,  'que-mh-fixed': 'Fixed table header' 
,  'jsqst-proj-delete-notify': 'The questionnaire is in use in the Project.  Are you sure you wish to delete selected items?' 
,  'jsqst-proj-new-notify': 'The questionnaire is in use in the Project.  Are you sure you wish to add new items?' 
,  'jsqst-copyto-notify': 'The questionnaire is in use in the Project.  Are you sure you wish to copy selected items?' 
,  'pro-ans-behalf': 'Answer behalf respondant' 
,  'jsur-rank-car-err': 'Please rank only %s answers' 
,  'jsur-rank-catmin-err': 'Please rank %s answers' 
,  'jsur-numvalid-err': 'Please provide an answer of a valid number' 
,  'pro-kiosk-mode': 'Kiosk mode' 
,  'pro-kiosk-mode-descr': 'Easy start over survey on same device' 
,  'jsur-start-over': 'Start over' 
,  'jsur-cancel': 'Cancel' 
,  'jsur-continue': 'Continue' 
,  'jsur-select': 'Select' 
,  'jsur-selected': 'Selected' 
,  'jsur-rank-sel': 'Select' 
,  'jsur-rank-drophere': 'Rank answers by dr drag and drop here' 
,  'jsur-month-list': 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec' 
,  'jsur-exited-title': 'You have successfully left the survey' 
,  'jsur-exited-descr': 'You may return to survey from where you left off' 
,  'jsur-exited-start': 'Return to survey' 
,  'jsur-mpick-count-err': 'Please select %s answers (Selected: %s)' 
,  'pro-concat-notice': 'Please notice! Concatenated vars won&#039;t be effectively added to project until sample file is initialized.' 
,  'sup-main-contrl': 'Main Control' 
,  'sup-monitor-title': 'Monitor &amp; View' 
,  'sup-quotas': 'Quotas' 
,  'sup-reponse': 'Response' 
,  'sup-logs': 'Logs' 
,  'sup-production': 'Production' 
,  'pro-offline': 'Offline' 
,  'pro-supervision': 'Supervision' 
,  'pro-gps-title': 'GPS Tracking' 
,  'pro-gps-descr': 'Track location coordinates from respondents' 
,  'pro-gps-force': 'Force location' 
,  'jsur-hm_nparalel': 'You cant select parallel answers' 
,  'jsur-hm_all': 'Please check all answers' 
,  'que-quest-edit': 'edit' 
,  'pro-dist-method': 'Choose distribution methods' 
,  'pro-spec-types': '' 
,  'pro-properties': 'Project properties' 
,  'pro-vars-title': 'Choose variables and create a population based on listfile' 
,  'pro-choose-var': 'Choose variable' 
,  'pro-quota-selvar': 'Create quotas for selected variables' 
,  'pro-quota-svar': 'Please select var' 
,  'pro-setup-wizard': 'Survey setup wizard' 
,  'pro-load': 'Load' 
,  'pro-status-number': 'Status number' 
,  'pro-status-empty': 'Empty' 
,  'pro-status-restored': 'Restored' 
,  'jque-num-rows': 'Rows number' 
,  'pro-status-title': 'Project status' 
,  'jlist-chacngepop-top': 'it will affect the following projects: ' 
,  'sup-i-inside': 'Inside' 
,  'sup-i-used': 'Used records' 
,  'jsur-logout': 'Logout' 
,  'jsur-curproj': 'Current project' 
,  'jsur-prj-change': 'Change' 
,  'jsur-status': 'Status' 
,  'jsur-finished': 'Finished successfully' 
,  'jsur-respid': 'Respondednt ID' 
,  'jsur-done-intlist': 'My successful interviews' 
,  'jsur-edit-open': 'Edit open answers' 
,  'jsur-resp-profile': 'Respondent profile' 
,  'jsur-resp-name': 'Respondednt name' 
,  'jsur-phone-nums': 'Phone numbers' 
,  'jsur-btn-manual': 'Manual dial' 
,  'jsur-btn-remove': 'Remove' 
,  'jsur-comments': 'Comments' 
,  'jsur-btn-post': 'Post' 
,  'jsur-write-post': 'Write comment here' 
,  'jsur-click-dial': 'Click to dial' 
,  'jsur-updates': 'Updates' 
,  'jsur-nextresp': 'Next respondent' 
,  'jsur-btn-tosurvey': 'To survey' 
,  'jsur-btn-failed': 'Failed' 
,  'jsur-btn-dealto': 'Please dial to' 
,  'jsur-btn-nextnumber': 'Next Number' 
,  'jsur-phonestat': 'Select status for phone number' 
,  'cal-select-proj': 'Select' 
,  'cal-btn-start': 'Start' 
,  'cal-btn-simulate': 'Simulate survey' 
,  'jsur-st-online': 'online' 
,  'jsur-st-on-break': 'on break' 
,  'jsur-st-on-task': 'in task' 
,  'jsur-st-in-task': 'in task' 
,  'jsur-dial-num': 'Dial number' 
,  'menu-projects': 'Projects' 
,  'menu-live': 'Live' 
,  'menu-production': 'Production' 
,  'menu-attendance': 'Attendance' 
,  'sup-i-readytime': 'Ready time' 
,  'sup-i-station': 'Station #' 
,  'sup-i-breaktime': 'Total break time' 
,  'sup-i-lostlogout': 'Last log out' 
,  'sup-i-lastologin': 'Last login' 
,  'sup-i-curproj': 'Current project' 
,  'sup-i-exists': 'Exits' 
,  'sup-i-recovered': 'Recovered' 
,  'sup-i-complete': 'Complete' 
,  'sup-i-goal': 'Goal' 
,  'sup-i-surtime': 'Avg survey time' 
,  'sup-i-gross': 'Gross' 
,  'sup-i-net': 'Net' 
,  'sup-i-totlaint': 'Total interviews' 
,  'sup-i-suration': 'Status duration ' 
,  'sup-i-status': 'Status' 
,  'sup-i-name': 'Name' 
,  'sup-i-msgall-lable': 'write your message' 
,  'sup-i-msgall-title': 'Send a message to all' 
,  'sup-i-msgall': 'Message all' 
,  'sup-i-discon-all': 'Disconnect all' 
,  'sup-i-logoff': 'Idle log off (minutes)' 
,  'sup-i-alert': 'Idle alert (minutes)' 
,  'sup-i-managecol': 'Manage columns' 
,  'sup-i-live-title': 'Interviewer live view' 
,  'sup-p-managesur': 'Manage surveys' 
,  'sup-p-complete-menu': 'Complete' 
,  'sup-p-projcomnment': 'Project comments' 
,  'sup-p-alocinter': 'Allocate interviewers' 
,  'sup-p-production': 'Production' 
,  'sup-p-statreport': 'Statuses report' 
,  'sup-p-ansdist': 'Answers distribution' 
,  'sup-p-quotastat': 'Quotas status' 
,  'sup-p-views': 'Views' 
,  'sup-p-nodetaild': 'No details' 
,  'sup-p-detaild': 'Details' 
,  'sup-p-remove': 'Remove' 
,  'sup-p-action': 'Actions' 
,  'sup-p-status': 'Status' 
,  'sup-p-interviews': 'Interviewers' 
,  'sup-p-left': 'Left' 
,  'sup-p-completed': 'Complete' 
,  'sup-p-to-sample': 'To sample' 
,  'sup-proj-name': 'Project name' 
,  'sup-pro-id': 'ID' 
,  'sup-i-ended-at': 'Ended at' 
,  'sup-i-started-at': 'Started at' 
,  'sup-i-survey-id': 'Survey ID' 
,  'sup-rem-confirm-title': 'This action will delete all unfinished surveys' 
,  'sup-remove-infinish': 'Remove not finished' 
,  'sup-serch-id-title': 'Search survey ID' 
,  'sup-comm-add': 'Add Comment' 
,  'sup-comm-lable': 'Comment something' 
,  'sup-inter-serach': 'Search interviewers' 
,  'sup-inter-all': 'All interviewers' 
,  'sup-inter-list': 'Interviewers list' 
,  'sup-aloc-inter-title': 'Allocated interview' 
,  'sup-inter-add': 'Add interviewers' 
,  'sup-inter-aloc': 'Interviewers allocated' 
,  'sup-prod-avg': 'Total avg' 
,  'sup-prod-sum': 'Total sum' 
,  'sup-prod-rep-title': 'Production report' 
,  'sup-a-completed': 'Completed only' 
,  'sup-a-all': 'All' 
,  'sup-a-selected': 'Selected' 
,  'sup-a-q-langs': 'Languages' 
,  'sup-a-q-status': 'Survey status' 
,  'sup-a-qlist': 'Questions to display' 
,  'sup-s-byinters': 'By interviewers' 
,  'status-RESTORE': 'RESTORE' 
,  'status-RETURNED_LOOP': 'RETURNED_LOOP' 
,  'status-RETURNED_LANGAUGE': 'RETURNED_LANGAUGE' 
,  'status-RETURNED_MEETING': 'ETURNED_MEETING' 
,  'status-RESTORED': 'RESTORED' 
,  'status-EMPTY': 'EMPTY' 
,  'status-IN_USE': 'IN_USE' 
,  'sup-s-count': 'Count' 
,  'sup-s-precent': 'Percent' 
,  'sup-s-res-count': 'Restore count' 
,  'sup-s-rec-restore': 'Records restored' 
,  'sup-s-call-export': 'Export call log' 
,  'sup-q-oveflow': 'Overflow' 
,  'sup-q-extras': 'Extras' 
,  'sup-q-refusals': 'Refusals' 
,  'sup-q-in-inter': 'In interview' 
,  'sup-q-open': 'Open' 
,  'sup-q-closed': 'Closed' 
,  'sup-mod-confirm': 'Are you sure?' 
,  'sup-i-arrived': 'Arrived' 
,  'sup-i-chekin': 'Check in' 
,  'sup-i-project': 'Project' 
,  'sup-i-start-shift': 'Start shift time' 
,  'sup-i-username': 'Username' 
,  'sup-i-cheking': 'Check in' 
,  'sup-all': 'All' 
,  'sup-list-by-proj': 'List by project' 
,  'sup-attend-title': 'Interviewers this shift' 
,  'sup-but-apply': 'Apply' 
,  'sup-to-date': 'To date' 
,  'sup-select-date': 'Select date' 
,  'sup-from-date': 'From date' 
,  'sup-m-byproj': 'By project' 
,  'sup-m-by-inter': 'By interviewer' 
,  'sup-default-col': 'Set defaults' 
,  'sup-mod-cancel': 'Cancel' 
,  'sup-mod-ok': 'OK' 
,  'sup-i-disconnect-all': 'Disconnect everyone' 
,  'sup-i-minutes': 'Minutes' 
,  'sup-qst': 'Qst' 
,  'sup-p-total-sum': 'Total sum' 
,  'sup-p-total-avg': 'Total avg' 
,  'status-RETURNED_LANGUAGE': 'RETURNED_LANGUAGE' 
,  'status-SUCCESS': 'SUCCESS' 
,  'status-ZERO_QUOTA': 'ZERO_QUOTA' 
,  'status-OVER_QUOTA': 'OVER_QUOTA' 
,  'status-EXTRA': 'EXTRA' 
,  'status-BURNED': 'BURNED' 
,  'jsur-phone': 'Phone' 
,  'sup-i-totalrec': 'Total records' 
,  'super-sample_size': 'Sample size' 
,  'super-name': 'Name' 
,  'super-remaining': 'Remaining' 
,  'sup-prod-rep-status': 'Status report' 
,  'sup-no-results': 'No data to display.' 
,  'sup-select-diff-dates': 'Plese try to select different dates' 
,  'proj-cookie-days': 'Days' 
,  'proj-cookie-unlim': 'Unlimited' 
,  'proj-cookie-expiry': 'Spam prevention' 
,  'sup-call-reord': 'Call recording' 
,  'sup-i-respodent': 'Respondent' 
,  'jsur-pbx-stop-dial': 'Stop dialing' 
,  'jsur-pbx-stop-dialing': 'Stop dialing' 
,  'jsur-pbx-dialing': 'dialing...' 
,  'jsur-connect-pbx-error': 'Can&#039;t connect to station' 
,  'jsur-redial': 'Redial' 
,  'jsur-exit-survey': 'Exit survey' 
,  'jsur-diconn-title': 'This call has been disconnected' 
,  'jsur-connect-pbx': 'Connecting to PBX' 
} 
             if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') { module.exports = my_dictionary } else { window.my_dictionary = my_dictionary } 